import { Adapter } from '@fmnts/core';
import { CampaignPage, CampaignPageAdapter } from './campaign-page';

/**
 * Form wrapper for unsubscribing for the self checkout
 */
export class UnsubscribeForm {
  constructor(
    /** Logo for the organization */
    public organizationLogo: string,
    /** Language for the form */
    public language: string,
    /** Locale for the form */
    public locale: string,
    /** Object containing the form */
    public form: CampaignPage,
    /** */
    readonly style: string,
  ) {}
}

export class UnsubscribeFormAdapter implements Adapter<UnsubscribeForm> {
  constructor(private pageAdapter = new CampaignPageAdapter()) {}
  adapt(item: Record<string, any>): UnsubscribeForm {
    return new UnsubscribeForm(
      item['organization_logo'],
      item['language'],
      item['locale'],
      this.pageAdapter.adapt(item['form']),
      item['style'],
    );
  }
}
